/**
 * Sprint 23.5 — HireDraftStyleSelect.
 *
 * Curated four-bucket enum (Q11). Pill row: clicked pill is selected; click
 * again to clear. A null value reads as "no opinion" — that's intentional;
 * the AI fills voice_tone for nuance.
 */

import type { CSSProperties } from "react";
import type { HirePersonaStyle } from "./types";

const STYLES: { key: HirePersonaStyle; label: string }[] = [
  { key: "matter-of-fact", label: "Matter-of-fact" },
  { key: "conversational", label: "Conversational" },
  { key: "playful", label: "Playful" },
  { key: "formal", label: "Formal" },
];

export interface HireDraftStyleSelectProps {
  value: HirePersonaStyle | null;
  onChange: (value: HirePersonaStyle | null) => void;
}

export function HireDraftStyleSelect({ value, onChange }: HireDraftStyleSelectProps) {
  return (
    <div style={wrap}>
      <div style={labelText}>Style</div>
      <div style={pillRow}>
        {STYLES.map(({ key, label }) => {
          const selected = value === key;
          return (
            <button
              type="button"
              key={key}
              onClick={() => onChange(selected ? null : key)}
              style={selected ? pillSelected : pill}
              aria-pressed={selected}
            >
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
}

const wrap: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: 6,
  paddingBottom: 10,
};

const labelText: CSSProperties = {
  fontSize: 11,
  fontWeight: 500,
  color: "var(--color-text-tertiary)",
  textTransform: "uppercase",
  letterSpacing: "0.04em",
};

const pillRow: CSSProperties = {
  display: "flex",
  flexWrap: "wrap",
  gap: 6,
};

const pill: CSSProperties = {
  fontSize: 12,
  padding: "4px 10px",
  borderRadius: 999,
  border: "var(--kuvio-border-default)",
  background: "var(--color-background-primary)",
  color: "var(--color-text-secondary)",
  cursor: "pointer",
  fontFamily: "var(--font-sans)",
};

const pillSelected: CSSProperties = {
  ...pill,
  background: "var(--color-text-primary)",
  color: "var(--color-background-primary)",
  borderColor: "var(--color-text-primary)",
};
